import React from 'react';

import styles from './NoAccessPage.module.scss';

import errorPageImg from 'assets/img/error_page.png';

const NoAccessPage = () => (
  <div className={styles.container}>
    <div className={styles.contentWrapper}>
      <div className={styles.imgWrapper}>
        <img src={errorPageImg} alt="No data icon" />
      </div>
      <h2 className={styles.title}>Access Denied</h2>
      <div className={styles.subTitle}>Sorry, you don&apos;t have permission to access this page.</div>
    </div>
  </div>
);

export default NoAccessPage;
